export default "__VITE_ASSET__DHe7s26J__"